export const PageHeadings = {
    BLS_FEEDBACK: "BLS Feedback",
    CUSTOMER_MANAGAMENT: "Customer Management",
};
